import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatetravelscompaniesinpune() {



  const cardData =
  {
    keyword: ' Corporate Travel Companies in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Travel Companies in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited is one of the leading corporate travel companies in Pune, providing reliable and professional transportation solutions for corporates, IT parks, and business hubs across the city. With a fleet of premium sedans, SUVs, and executive cars, we ensure comfortable, punctual, and safe travel for employees, clients, and senior executives. From daily office commute and airport transfers to client visits and VIP travel, our customized rental plans, trained chauffeurs, and well-maintained vehicles deliver a seamless and premium corporate travel experience for businesses in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Corporate Transportation Agency Pune",
    "description": "Corporate Transportation Agency Pune provides end-to-end mobility solutions for companies requiring safe, structured, and large-scale employee commute services. With AC sedans, SUVs, vans, and shuttle buses, the agency ensures punctuality, safety, and smooth daily movement. Corporate Transportation Agency Pune is trusted for its professional chauffeurs, GPS-enabled vehicles, and optimized travel routes."
  },
  {
    "name": "Business Travel Solutions Pune",
    "description": "Business Travel Solutions Pune offers premium, customizable travel services for executives, managers, and business teams. From airport transfers to intercity visits and corporate tours, the service ensures comfort, punctuality, and professional travel management. Business Travel Solutions Pune provides luxury cars, SUVs, and chauffeur-driven vehicles for seamless business travel."
  },
  {
    "name": "Corporate Fleet Provider Pune",
    "description": "Corporate Fleet Provider Pune delivers dedicated fleets of sedans, SUVs, staff shuttles, and corporate cabs tailored to organizational needs. Ideal for employee commute, executive travel, and long-term fleet assignments, the service offers professional drivers, fleet monitoring, and reliable daily operations."
  },
  {
    "name": "Employee Mobility Companies Pune",
    "description": "Employee Mobility Companies Pune specialize in managing large-scale employee transportation through structured routing, safe travel practices, and multi-shift support. With modern vehicles and verified drivers, these companies ensure efficient workforce mobility across Pune’s corporate and industrial hubs."
  },
  {
    "name": "Staff Transportation Vendor Pune",
    "description": "Staff Transportation Vendor Pune provides dependable and cost-effective commuting solutions for office staff, factory workers, and corporate employees. With AC cabs, shared vans, and shuttles, the service ensures timely daily travel with complete route coordination and shift-based scheduling."
  },
  {
    "name": "Corporate Travel Management Pune",
    "description": "Corporate Travel Management Pune offers comprehensive business travel planning including executive cab services, airport transfers, multi-location travel, and outstation corporate trips. With a professional fleet and seamless coordination, the service ensures smooth travel for teams and senior management."
  },
  {
    "name": "Office Commute Management Pune",
    "description": "Office Commute Management Pune handles complete daily travel operations for companies through automated routing, trained drivers, vehicle monitoring, and multi-shift scheduling. It ensures reliable and safe employee commute with efficient coordination across residential and office zones."
  },
  {
    "name": "Corporate Taxi Operators Pune",
    "description": "Corporate Taxi Operators Pune operate a fleet of clean, well-maintained sedans and SUVs exclusively for corporate mobility. Ideal for staff travel, meetings, airport transfers, and intercity movement, the service ensures punctual, safe, and comfortable corporate taxi travel."
  },
  {
    "name": "Corporate Car Rental Companies Pune",
    "description": "Corporate Car Rental Companies Pune offer flexible daily, weekly, and monthly rental options for companies needing dedicated cars for business travel. With professional chauffeurs, luxury cars, and reliable service quality, these companies support smooth executive and staff mobility."
  },
  {
    "name": "Corporate Shuttle Provider Pune",
    "description": "Corporate Shuttle Provider Pune delivers high-capacity shuttle vans and minibuses for companies requiring bulk employee transportation. The service supports multi-shift operations, fixed routes, and safe commuting for large teams across corporate parks and industrial zones."
  },
  {
    "name": "Employee Transport Agency Pune",
    "description": "Employee Transport Agency Pune offers structured daily pickup–drop services for employees working in IT parks, corporate offices, and industrial areas. With GPS-enabled vehicles and verified chauffeurs, the service ensures reliable and safe employee mobility for all shift timings."
  },
  {
    "name": "Business Tour Operators Pune",
    "description": "Business Tour Operators Pune provide specialized corporate travel arrangements including intercity tours, business events, plant visits, and team travel. With premium vehicles, skilled drivers, and well-planned itineraries, the service ensures smooth and organized corporate touring experiences."
  },
  {
    "name": "Pune Corporate Travel Experts",
    "description": "Pune Corporate Travel Experts deliver professional and end-to-end travel solutions tailored for corporate needs. From executive cab services to fleet management and outstation travel, they ensure reliable, comfortable, and efficient travel coordination for companies across Pune."
  },
  {
    "name": "Office Cab Vendors Pune",
    "description": "Office Cab Vendors Pune supply reliable and safe cab services for daily office commuting. With AC sedans, hatchbacks, and vans, the service ensures timely and comfortable employee transportation supported by trained drivers and efficient operations management."
  },
  {
    "name": "Employee Commute Companies Pune",
    "description": "Employee Commute Companies Pune specialize in handling large-scale employee travel with optimized routes, multi-shift support, and dependable vehicle fleets. These companies ensure safe, efficient, and organized employee movement across Pune’s major business districts."
  }
],
"tableData": [
  ["Corporate Transportation Agency Pune", "Business Travel Solutions Pune"],
  ["Corporate Fleet Provider Pune", "Employee Mobility Companies Pune"],
  ["Staff Transportation Vendor Pune", "Corporate Travel Management Pune"],
  ["Office Commute Management Pune", "Corporate Taxi Operators Pune"],
  ["Corporate Car Rental Companies Pune", "Corporate Shuttle Provider Pune"],
  ["Employee Transport Agency Pune", "Business Tour Operators Pune"],
  ["Pune Corporate Travel Experts", "Office Cab Vendors Pune"],
  ["Employee Commute Companies Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Travel Companies in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited is one of the leading corporate travel companies in Pune, offering reliable employee transportation and executive travel solutions."
  },
  {
    "WhyChooseheading": "End-to-End Corporate Travel Solutions",
    "WhyChoosedescription": "We provide complete travel management including employee pickup & drop, outstation travel, airport transfers, and corporate event transportation."
  },
  {
    "WhyChooseheading": "Comfortable & Well-Maintained Fleet",
    "WhyChoosedescription": "Our fleet includes sedans, SUVs, tempo travellers, and buses—all sanitized, safe, and comfortable for corporate commuting."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and cost-effective travel plans tailored to match the needs of startups, SMEs, and large enterprises."
  },
  {
    "WhyChooseheading": "Reliable & On-Time Service",
    "WhyChoosedescription": "Punctual pickup and drop services ensure hassle-free employee transportation across all major corporate hubs in Pune."
  },
  {
    "WhyChooseheading": "Experienced & Professional Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers ensure safe, disciplined, and comfortable travel for employees and executives."
  },
  {
    "WhyChooseheading": "24/7 Travel Assistance",
    "WhyChoosedescription": "We offer round-the-clock support for bookings, emergencies, and schedule adjustments to ensure seamless corporate travel."
  },
  {
    "WhyChooseheading": "Easy Booking & Quick Coordination",
    "WhyChoosedescription": "Corporate travel can be managed effortlessly through our smooth and efficient booking and coordination process."
  }
]

























  }

const faqData = [
  {
    question: 'Is Pune Corporate Cars India Private Limited one of the leading corporate travel companies in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited is a trusted and professional corporate travel company offering comprehensive travel solutions in Pune.',
  },
  {
    question: 'What services do you offer as a corporate travel company in Pune?',
    answer: 'We provide corporate cab services, employee transportation, airport transfers, outstation travel, and dedicated business travel solutions.',
  },
  {
    question: 'How can companies book corporate travel services with Pune Corporate Cars India Private Limited?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'Do you offer customized travel plans for corporate clients?',
    answer: 'Yes, we offer tailored travel plans based on the company’s requirements, staff strength, and travel frequency.',
  },
  {
    question: 'What vehicle options are available for corporate travel in Pune?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, and tempo travellers depending on travel needs.',
  },
  {
    question: 'Can companies avail monthly or annual corporate travel contracts?',
    answer: 'Absolutely. We provide flexible monthly and annual corporate travel contracts with transparent pricing.',
  },
  {
    question: 'Do you offer airport transfer services for corporate travelers?',
    answer: 'Yes, we provide punctual and reliable airport pickup and drop services for corporate customers.',
  },
  {
    question: 'What safety measures do you follow for corporate travel services?',
    answer: 'Our vehicles are GPS-enabled, sanitized regularly, and our drivers follow strict safety and hygiene standards.',
  },
  {
    question: 'What payment modes are available for corporate travel services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Varun Shirole',
    feedback: 'Pune Corporate Cars India Private Limited has been our preferred corporate travel partner. Excellent service and great professionalism.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Tanvi Kamat',
    feedback: 'Their corporate travel services are very reliable and efficient. Perfect solution for our business travel needs.',
    rating: 5,
  },
];


















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Travel Companies in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-travel-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides professional corporate travel services in Pune, offering business travel solutions, employee transportation, office commute management, and corporate fleet services. Reliable and chauffeur-driven cabs for companies, IT parks, and business centers.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "4800", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-travel-companies-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Corporate Travel Companies in Pune | Employee & Business Travel Solutions | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides professional corporate travel services in Pune, offering business travel solutions, employee transportation, office commute management, and corporate fleet services. Reliable and chauffeur-driven cabs for companies, IT parks, and business centers."
  />

  <meta
    name="keywords"
    content="Corporate Transportation Agency Pune, Business Travel Solutions Pune, Corporate Fleet Provider Pune, Employee Mobility Companies Pune, Staff Transportation Vendor Pune, Corporate Travel Management Pune, Office Commute Management Pune, Corporate Taxi Operators Pune, Corporate Car Rental Companies Pune, Corporate Shuttle Provider Pune, Employee Transport Agency Pune, Business Tour Operators Pune, Pune Corporate Travel Experts, Office Cab Vendors Pune, Employee Commute Companies Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatetravelscompaniesinpune;